import { useRef } from 'react';

// Это будет глобальный ref для доступа к toast из любого компонента
let globalToastRef = null;

export const setGlobalToastRef = (ref) => {
  globalToastRef = ref;
};

export const useAppToast = () => {
  return {
    success: (message, duration) => {
      if (globalToastRef?.current) {
        globalToastRef.current.success(message, duration);
      } else {
        console.error('ToastManager не инициализирован');
        // fallback на обычный alert для разработки
        alert(`SUCCESS: ${message}`);
      }
    },
    error: (message, duration) => {
      if (globalToastRef?.current) {
        globalToastRef.current.error(message, duration);
      } else {
        console.error('ToastManager не инициализирован');
        // fallback на обычный alert для разработки
        alert(`ERROR: ${message}`);
      }
    },
    warning: (message, duration) => {
      if (globalToastRef?.current) {
        globalToastRef.current.warning(message, duration);
      } else {
        console.error('ToastManager не инициализирован');
        // fallback на обычный alert для разработки
        alert(`WARNING: ${message}`);
      }
    },
    info: (message, duration) => {
      if (globalToastRef?.current) {
        globalToastRef.current.info(message, duration);
      } else {
        console.error('ToastManager не инициализирован');
        // fallback на обычный alert для разработки
        alert(`INFO: ${message}`);
      }
    }
  };
};

export default useAppToast;